export interface IModal {
    title?: string;
    content?: string;
    color?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
    icon?: string;
    list?: string[];
}

export interface IModalData {
    title?: string;
    data?: any;
    size?: string;
    showButtons?: boolean;
    showMaximize?: boolean;
    confirmButton?: string;
    cancelButton?: string;
    hiddeHeader?: boolean;
}

export enum ModalTypeEnum {
    INFO,
    WARNING,
    ERROR,
    CONFIRM,
    SUCCESS
}

export const MODAL_MESSAGES = {
    ATENCION: '¡Atención!',
    INFORMACION: '¡Información!',
    CONFIRMAR: '¡Confirmar!',
    ERROR: '¡Error!',
    EXITO: '¡Completado!',
    ADVERTENCIA: '¡Advertencia!',
    CONTINUAR: 'Continuar',
    CANCELAR: 'Cancelar',
    ACEPTAR: 'Aceptar',
    exitoOperacion:  '¡Operación completada correctamente!',
    errorOperacion:  'No se pudo completar la acción. Intenta nuevamente',
    cargando: 'Cargando...',
    guardando: 'Guardando...',
    actualizando: 'Actualizando...',
    eliminando: 'Eliminando...',
    sesionExpired: 'Tu sesión ha caducado. Por favor ingresa nuevamente.',
};

export const MODAL_ICONS = {
    INFO: 'info-circle',
    WARNING: 'exclamation-triangle',
    ERROR: 'times-circle',
    CONFIRM: 'question-circle',
    SUCCESS: 'check-circle',
};

export const MODAL_COLORS = {
    DARK: 'dark',
    DANGER: 'danger',
    SUCCESS: 'success',
    PRIMARY: 'primary',
    WARNING: 'warning',
};